import { Injectable } from '@angular/core';
import { Item } from '../models/item.model';
import { Automobilia } from '../models/automobilia.model';
import {WantedItem} from '../models/wanted-item.model';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  private _item: Item;
  private _automobilia: Automobilia;
  private _carWanted: WantedItem;

  constructor() { }

  get item(): Item {
    return this._item;
  }

  set item(value: Item) {
    this._item = value;
  }

  get automobilia(): Automobilia {
    return this._automobilia;
  }

  set automobilia(value: Automobilia) {
    this._automobilia = value;
  }

  get carWanted(): WantedItem {
    return this._carWanted;
  }

  set carWanted(value: WantedItem) {
    this._carWanted = value;
  }

}
